module.exports = __webpack_public_path__ + "static/breedon_card_twitter-0c201ed5686a94fa363de371ccc3511c.jpg";